import * as React from 'react'
import Content from '../../../pages/shared/content'

export enum driveDestinations {
  surprise = 1,
  rural,
  urban,
}

export type PerDriveDestination<T> = { [key in driveDestinations]: T }

export interface DaysAndDriveDestination {
  dest: driveDestinations
  days: number
}

export function getPlaceholder(value: driveDestinations) {
  const options: PerDriveDestination<string> = {
    [driveDestinations.surprise]: 'Surprise me',
    [driveDestinations.rural]: 'Rural',
    [driveDestinations.urban]: 'Urban',
  }

  return options[value] || 'Not in enum'
}

export function getDestination(value: driveDestinations) {
  return (
    <Content addNode contentKey={`destination-${driveDestinations[value]}`}>
      {getPlaceholder(value)}
    </Content>
  )
}

export function getDestinationFromValue(value: DaysAndDriveDestination) {
  return getDestination(value.dest)
}

export function getDriveDestinationString(dest: driveDestinations) {
  switch (dest) {
    case driveDestinations.rural:
      return 'rural'
    case driveDestinations.urban:
      return 'urban'
    case driveDestinations.surprise:
    default:
      return 'any'
  }
}
